import { useNodePropertyPanel } from 'features/processFlowDiagrams/components/nodes/propertyPanel/NodePropertyPanelContext'
import {
  AddMetadataButton,
  FormSection,
  MetadataContainer,
  MetadataInput,
  MetadataRemoveButton,
  MetadataRow,
  SectionTitle,
} from 'features/processFlowDiagrams/components/nodes/propertyPanel/StylesAndHelper'
import React, { useState } from 'react'

/** Editable key-value metadata pairs attached to the selected node. */
export const MetadataSection: React.FC = () => {
  const { metadata, handleMetadataChange, handleMetadataRemove } =
    useNodePropertyPanel()

  const [newMetadataKey, setNewMetadataKey] = useState('')
  const [newMetadataValue, setNewMetadataValue] = useState('')

  const handleAdd = () => {
    if (newMetadataKey.trim()) {
      handleMetadataChange(newMetadataKey.trim(), newMetadataValue)
      setNewMetadataKey('')
      setNewMetadataValue('')
    }
  }

  return (
    <FormSection>
      <SectionTitle>Metadata</SectionTitle>
      <MetadataContainer>
        {Object.entries(metadata).map(([key, value]) => (
          <MetadataRow key={key}>
            <MetadataInput value={key} disabled placeholder='Key' />
            <MetadataInput
              value={value}
              onChange={(e) => handleMetadataChange(key, e.target.value)}
              placeholder='Value'
            />
            <MetadataRemoveButton onClick={() => handleMetadataRemove(key)}>
              ×
            </MetadataRemoveButton>
          </MetadataRow>
        ))}
        <MetadataRow>
          <MetadataInput
            value={newMetadataKey}
            onChange={(e) => setNewMetadataKey(e.target.value)}
            placeholder='New key'
          />
          <MetadataInput
            value={newMetadataValue}
            onChange={(e) => setNewMetadataValue(e.target.value)}
            placeholder='Value'
            onKeyDown={(e) => {
              if (e.key === 'Enter') handleAdd()
            }}
          />
        </MetadataRow>
        <AddMetadataButton onClick={handleAdd}>+ Add</AddMetadataButton>
      </MetadataContainer>
    </FormSection>
  )
}
